import { Flag } from '../../shared/models/flag.model';
import { VesselType } from '../../shared/models/vesselType.model';
import { ClassificationSociety } from '../../shared/models/classificationSociety.model';
import { Attachment } from '../../shared/models/attachment.model';
import { NearestLocation, Authority, MesurementUnit, FrequencyUnit } from '../../../shared/models/enums.model';
import { BaseRequest } from '../../../shared/models/base-request.model';

export class RepairRequestDTO
{

    Id:string;
    RequestorId:string;
    VesselName:string;
    IMONo:string;
    LengthOverAll:number;
    LengthOverAllUnit:MesurementUnit;
    LengthBetweenPerpendiculars:number;
    LengthBetweenPerpendicularsUnit:MesurementUnit;
    Beam:number;
    BeamUnit:MesurementUnit;
    MouldedDepth:number;
    MouldedDepthUnit:MesurementUnit;
    SuezCanalNetTonnage?:number;
    SuezCanalGrossTonnage?:number;
    Lightweight:number;
    Deadweight:number;
    Displacement:number;
    Draught:number;
    DraughtUnit:MesurementUnit;
    Trim:number;
    TrimUnit:MesurementUnit;
    List:number;
    ListUnit:MesurementUnit;
    Frequency:number;;
    FrequencyUnit:FrequencyUnit;
    RatedCurrentDuringDocking:number;
    WorkDescription:string;
    RequiredDockingDate:Date;
    Flag :Flag;
    FlagId:number;
    ClassificationSociety :ClassificationSociety;
    ClassificationSocietyId:number;
    VesselType:VesselType;
    VesselTypeId:number;
    Attachments:Attachment[]= [];
    NearestLocation :NearestLocation;
    Authority :Authority;
    DockingPlan:string;
    GeneralArrangement:string;
    TankPlan:string;
    LinesPlan:string;
    TransverseSectionPlan:string;
    FreeGasCertificate:string;
    DetailedScopeOfWork:string;
    MobileNumber:string;
    Fax:string;
    CustomerName:string;
    UserName:string;
    baseRequest :BaseRequest;

}









